import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/tabri")({
  beforeLoad: () => {
    throw redirect({ href: "https://ceopractitionernetwork.com", replace: true });
  },
  head: () => ({
    meta: [
      { title: "CEO Practitioner Network | Tables and Bridges" },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: "https://ceopractitionernetwork.com" }],
  }),
  component: () => null,
});

